<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <title-edit header="Partner" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="3" xs="12">
        <v-app class="switch-app">
          <v-switch label="Main partner" v-model="form.is_main_partner"></v-switch>
        </v-app>
      </v-col>
      <v-col cols="12" sm="2" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Orders* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.orders" @update="updateOrders" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Branch :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Partner name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Partner name EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Url :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.url" @update="updateUrl" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Image name :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.image_name" @update="updateImageName" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Image path :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-image-upload id="image1" :model="form.image_path_show" :name="form.image_name" @update="updateImage" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deletePartnerData" @save-info="savePartnerData"
      @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import DeleteButton from "../../../components/Button/DeleteButton";
import InputTextField from "../../../components/Input/InputTextField";
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import { mapState } from "vuex";
import SelectOption from "../../../components/Input/selectOption";
import { permissionPartner, role } from "../../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../../components/Layout/CommandButton";
import Loading from 'vue-loading-overlay';

export default {
  name: "PartnerEdit",
  components: {
    CommandButton,
    SelectOption,
    InputImageUpload,
    SaveButton, PreviewButton, LineHr,
    TitleEdit, InputTextField, DeleteButton,
    Loading
  },
  computed: {
    permissionPartner,
    ...mapState({
      form: state => {
        return state.Partner.form;
      }
    })
  },
  data() {
    return {
      optionBranch: [],
      permission: null,
      isLoading: false
    }
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    saveClose() {
      this.$store.dispatch("Partner/savePartner", {
        id: this.form.partner_id,
        data: this.form
      }).then(res => {
        Swal(res.response_msg);
        if (res.response_code == 200) {
          this.goToPartnerTable();
        }
      }).catch(() => {
        Swal('', 'Cannot save partner', 'error');
      })
    },
    savePartnerData() {
      this.isLoading = true
      this.$store.dispatch("Partner/savePartner", {
        id: this.form.partner_id,
        data: this.form
      }).then(res => {
        this.isLoading = false;
        Swal(res.response_msg);
      }).catch(() => {
        this.isLoading = false;
        Swal('', 'Cannot save partner', 'error');
      })
    },
    deletePartnerData() {
      this.$store.dispatch("Partner/deletePartner", this.form.partner_id).then(res => {
        Swal(res.response_msg);
        if (res.response_code == 200) {
          this.goToPartnerTable();
        }
      }).catch(() => {
        Swal('', 'Cannot delete partner', 'error');
      })
    },
    goToPartnerTable() {
      this.$router.push("/about/partner");
    },
    updateOrders(val) {
      this.form.orders = val;
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateUrl(val) {
      this.form.url = val;
    },
    updateImageName(val) {
      this.form.image_name = val;
    },
    updateImage(val) {
      this.form.image_path = val.imagePath;
      this.form.image_path_show = val.fullImagePath;
    },
  }
}
</script>

<style scoped></style>
